import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Promotion {

  static endpoints = {
    index: `${baseUrl}/promotions`,
  };

  static find(payload) {
    return axios.post(`${this.endpoints.index}/find`, payload).then((response)=> response.data);
  };

  static claim(payload) {
    return axios.post(`${this.endpoints.index}/claim`, payload).then((response)=> response.data.points);
  };

}



